// extracted by mini-css-extract-plugin
export default {"Content":"NotFound_Content__pc64F","GoHomeButton":"NotFound_GoHomeButton__LoxUa"};